import PropTypes from 'prop-types'
import '../../../../../styles/scss/wordlist-item/wordlistitem.scss'
import PrivilegesUtil from '../../../../utils/PrivilegesUtil'
import Privileges from '../../../../../const/Privileges'
import WordListUtils from '../../../../utils/WordListUtils'
import Constants from '../../../../../const/Constants'
import Speaker from '../../../../elements/svg_icons/Speaker'
import { Button, Dropdown, Flex, Modal, Progress, Space, Tooltip } from 'antd'
import { useState } from 'react'
import { deleteWordList, fetchWorldLists } from '../../../../../store/wordLists/extraReducers'
import { wordListByIdSelector } from '../../../../../store/wordLists'
import { premiumStatusSelector, userSelector } from '../../../../../store/global'
import Loading from '../../../../elements/loading/Loading'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import IconLetterCase from '../../../../elements/svg_icons/IconLetterCase'
import * as API_DONE_WORDLIST from '../../../../../shared/http/done-word-list'
import EditCardListDialog from '../../../../modalwindows/EditCardListDialog'
import { EllipsisOutlined, PlayCircleOutlined, UnorderedListOutlined } from '@ant-design/icons'
import { DropdownCardMenu } from '../../profilepage/newProfile/DropdownCardMenu'
import ConfirmModalDialog from '../../../../modalwindows/ConfirmModalDialog'
import CloneToCommunityModalDialog from '../../../../modalwindows/CloneToCommunityModalDialog'
import { communitiesDataSelector } from '../../../../../store/communities'
import { CardsDictionaryDialog } from '../../../../modalwindows/CardsDictionaryDialog'
import { GEButton } from '../../../../../common/buttons'
import LearnCardDialog from '../../../../modalwindows/LearnCardDialog'
import * as API_SUBMIT_WORDLIST from '../../../../../shared/http/submitWordList'

import { Typography } from 'antd';
import CardImageUtils from "../../../../utils/CardImageUtils";
const { Text } = Typography;

const WordListItem = (props: any) => {
    const user = useAppSelector(userSelector)
    const dispatch = useAppDispatch()
    const communities = useAppSelector(communitiesDataSelector)
    const isPremium = useAppSelector(premiumStatusSelector)
    const { id, listName, type, level, repeatedDate, imageId, tree, countWords } = props.wordList
    const canEditWordList = WordListUtils.canEditWordList(props.wordList, user, props.canEditCommunity)
    const [showEditListDialog, setShowEditListDialog] = useState(false)
    const [showCloneToCommunityModal, setShowCloneToCommunityModal] = useState(false)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showCardsDictionaryDialog, setShowCardsDictionaryDialog] = useState(false)
    const [showLearnCardsDialog, setShowLearnCardsDialog] = useState(false)

    /**
     * Сделать список слов готовым
     * @param id
     */
    const makeListDone = (id: any) =>
        API_DONE_WORDLIST.transformUserListToDoneList(id).then(() => {
            dispatch(fetchWorldLists())
        })

    /**
     * Сделать все буквы в листе заглаными
     * @param id
     */
    const makeLettersUppercase = (id: any) =>
        API_DONE_WORDLIST.makeLettersUppercase(id).then(() => {
            dispatch(fetchWorldLists())
        })

    const wordList = useAppSelector(wordListByIdSelector(id))

    const getWordListItemClassName = (wlType: any, wlChecked: any) => {
        const defaultClassName = 'dictionary__word-list-item'
        let isDone = WordListUtils.isDoneType(wlType) ? 'yellowBackGround' : 'blueBackGround'
        let isSelected = wlChecked ? 'dictionary__word-list-item-selected' : ''
        return defaultClassName + ' ' + isDone + ' ' + isSelected
    }
    /**
     * Модальное окно для редактирования карточки
     */
    const closeEditCardListDialog = () => setShowEditListDialog(false)
    const openEditCardListDialog = () => {
        setShowEditListDialog(true)
    }

    /**
     * Модальное окно для клонирования карточки
     */
    const openCloneToCommunityModal = () => {
        setShowCloneToCommunityModal(true)
    }

    /**
     * Модальное окно для удаления карточки
     */
    const openConfirmModal = () => {
        setShowConfirmModal(true)
    }
    const closeConfirmModal = () => setShowConfirmModal(false)
    const deleteCardList = () => {
        dispatch(deleteWordList(wordList.id))
    }

    const adminCommunities = communities ? communities.filter((c: any) => c.canEdit) : []

    const isString = (variable: any) => {
        return typeof variable === 'string'
    }


    const getProgressBar = (rD: any) => {
        const width = 35
        const type = 'circle'
        const daysToRepeat = WordListUtils.calculateDaysToRepeat(repeatedDate)
        if (daysToRepeat <= 0) {
            return (
                <Progress
                    width={width}
                    type={type}
                    strokeColor={'red'}
                    status={'normal'}
                    percent={100}
                    format={(percent: any) => '0'}
                />
            )
        } else if (daysToRepeat <= 100) {
            return (
                <Progress
                    width={width}
                    type={type}
                    strokeColor={'green'}
                    status={'normal'}
                    percent={100 - daysToRepeat}
                    format={(percent: any) => `${100 - percent}`}
                />
            )
        }
        return (
            <Progress
                width={width}
                type={type}
                strokeColor={'green'}
                status={'normal'}
                percent={0}
                format={(percent: any) => '100+'}
            />
        )
    }

    const submitList = (listId: any) => {
        API_SUBMIT_WORDLIST.submit(listId)
            // @ts-ignore
            .then(() => {
                Modal.success({
                    centered: true,
                    destroyOnClose: true,
                    okText: 'Понятно',
                    // @ts-ignore
                    getContainer: () => document.querySelector('#dictionary'),
                    content: (
                        <span>
                            Спасибо за список, постараемся рассмотреть его в ближайшее время!
                        </span>
                    )
                })
            })
    }

    const handleMenuClick = (e: any) => {
        switch (e.key) {
            case DropdownCardMenu.RENAME:
                openEditCardListDialog()
                break

            case DropdownCardMenu.CLONE_INTO_COMMUNITY:
                openCloneToCommunityModal()
                break

            case DropdownCardMenu.DELETE_CARD:
                openConfirmModal()
                break

            case DropdownCardMenu.SHARE_LIST:
                props.shareWordList(id)
                break

            case DropdownCardMenu.MAKE_READY:
                submitList(id)
                break
        }
    }

    const createItems = () => {
        const result = []
        result.push({
            label: 'Редактировать',
            key: DropdownCardMenu.RENAME
        })
        if (isPremium && adminCommunities.length > 0) {
            result.push({
                label: 'Копировать в сообщество',
                key: DropdownCardMenu.CLONE_INTO_COMMUNITY
            })
        }
        if (WordListUtils.isCommunityType(type)) {
            result.push({
                label: 'Поделиться',
                key: DropdownCardMenu.SHARE_LIST
            })
        }
        result.push({
            label: 'Удалить',
            key: DropdownCardMenu.DELETE_CARD
        })
        result.push({
            label: 'Предложить сделать готовым',
            key: DropdownCardMenu.MAKE_READY
        })
        return result
    }

    const items = createItems()

    const menuItems = {
        items,
        onClick: handleMenuClick
    }

    const closeModal = () => {
        setShowCardsDictionaryDialog(false)
    }

    const openLearnCardsDialog = () => {
        setShowLearnCardsDialog(true)
    }

    return (
        <>
            {wordList.isLoading ? (
                <Loading />
            ) : (
                <li className={getWordListItemClassName(type, wordList?.checked)}>
                    {/*image — compact 44px*/}
                    <img
                        src={CardImageUtils.getCardImage(tree)}
                        alt={listName}
                        className="word-list-item__image"
                        loading="lazy"
                    />

                    {/*info*/}
                    <div className="word-list-item__info">
                        <Text
                            className="word-list-item__list-name"
                            ellipsis={{ tooltip: true }}
                        >
                            {listName}
                        </Text>
                        <span className="word-list-item__count-words">
                            {countWords} {WordListUtils.pluralizeWords(countWords)}
                            {level && <> · {level}</>}
                        </span>
                    </div>

                    {/*actions — full height buttons*/}
                    <div className="word-list-item__actions">
                        <button
                            className="word-list-item__action-btn"
                            onClick={openLearnCardsDialog}
                            title="Повторить"
                            type="button"
                        >
                            <PlayCircleOutlined />
                            <span>Повторить</span>
                        </button>
                        <button
                            className="word-list-item__action-btn"
                            onClick={() => setShowCardsDictionaryDialog(true)}
                            title="Слова"
                            type="button"
                        >
                            <UnorderedListOutlined />
                            <span>Слова</span>
                        </button>
                        {(canEditWordList || WordListUtils.isNewWordList(id)) && (
                            <Dropdown menu={menuItems} trigger={['click']}>
                                <button
                                    className="word-list-item__action-btn word-list-item__action-btn--menu"
                                    title="Ещё"
                                    type="button"
                                >
                                    <EllipsisOutlined />
                                </button>
                            </Dropdown>
                        )}
                    </div>

                    {PrivilegesUtil.hasPrivilege(user, Privileges.EDIT_DONE_WORD_LIST) && (
                        <div className='word-list-item__admin-btns'>
                            {(WordListUtils.isUserType(type) || WordListUtils.isCommunityType(type)) && (
                                <>
                                    <Speaker onClick={() => makeListDone(id)} class='fill-white' />
                                    <IconLetterCase onClick={() => makeLettersUppercase(id)} class='fill-white' />
                                </>
                            )}
                            {WordListUtils.isDoneType(type) && (
                                <IconLetterCase onClick={() => makeLettersUppercase(id)} class='fill-white' />
                            )}
                        </div>
                    )}

                    <EditCardListDialog
                        decline={closeEditCardListDialog}
                        open={showEditListDialog}
                        cardList={props.wordList} />
                    <CloneToCommunityModalDialog
                        cardList={wordList}
                        communities={adminCommunities}
                        open={showCloneToCommunityModal}
                        close={() => setShowCloneToCommunityModal(false)} />
                    <ConfirmModalDialog
                        decline={closeConfirmModal}
                        message={'Вы уверены, что хотите удалить список карточек?'}
                        open={showConfirmModal}
                        confirm={deleteCardList} />

                    {showCardsDictionaryDialog &&
                    <CardsDictionaryDialog wordList={wordList} isOpen={showCardsDictionaryDialog}
                                           canEditWordList={canEditWordList}
                                           close={closeModal as any} />}
                    <LearnCardDialog wordList={wordList} open={showLearnCardsDialog}
                                     close={() => setShowLearnCardsDialog(false)} />
                </li>
            )}
        </>
    )
}

export default WordListItem

WordListItem.propTypes = {
    cancelEdit: PropTypes.func,
    deleteWordList: PropTypes.func,
    editMode: PropTypes.func,
    onChangeListName: PropTypes.func,
    onChangeListLevel: PropTypes.func,
    selectWordList: PropTypes.func,
    shareWordList: PropTypes.func.isRequired,
    wordList: PropTypes.object
}
